import { createSlice } from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { IInitialState } from "./Types";


const initialState: IInitialState = {
  yearsList:[],
  selectedYear: "",
  isCollapsedView: false
};

export const Slice = createSlice({
  initialState,
  name: "financial-year-reducer",
  reducers: Reducer,
});
